define.alias("shared/components/shared/ember-drop-multi-select-item", "media/components/shared/ember-drop-multi-select-item");